import { ConnectDragPreview, ConnectDragSource, DragSourceMonitor, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { AssetDragObject, ImageMap } from 'models';

type Props = {
  component: ImageMap;
  isImageBeingUploaded: boolean;
  imageSource: string;
};

type DragSourceHook = {
  isDragging: boolean;
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
};

export const useImageListItemDragSource = ({ component, isImageBeingUploaded, imageSource }: Props): DragSourceHook => {
  const dispatch = useDispatch();
  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const componentType = EntityType.IMAGE;
  const [{ isDragging }, dragRef, preview] = useDrag<AssetDragObject, void, { isDragging: boolean }>({
    type: dragSourceType,
    canDrag: !isImageBeingUploaded && !!imageSource,
    item: () => {
      dispatch(toggleDragState(dragSourceType, componentType));

      return {
        type: componentType,
        component,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },
    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    isDragging,
    dragRef,
    preview,
  };
};
